// extracted by mini-css-extract-plugin
export default {"plain-text":"sFA-mzGrgK","plainText":"sFA-mzGrgK"};
    if(module.hot) {
      // 1625219509836
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  